var _g, _g2, _g3, _circle, _g4, _g5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMooncatConfetti(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_176_105503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.7739 67.0112C70.96 68.1727 70.2899 69.4298 69.7717 70.7501C68.2284 74.6817 66.8855 77.9327 65.4156 80.7449C64.5543 82.3927 64.0178 84.2045 64.0224 86.0638L64.0604 101.245H22.0638L22.0911 86.2619C22.0945 84.3854 21.5463 82.5583 20.671 80.8985C19.1694 78.0512 17.8057 74.7535 16.2343 70.7501C15.716 69.4298 15.046 68.1728 14.232 67.0112L8.91426 59.4227L5.57053 58.5063C3.67856 57.9878 2.28421 56.3821 2.03607 54.4361C1.65002 51.4087 4.11245 48.9743 7.16439 48.9742C10.5298 48.9742 12.3358 50.337 13.3214 52.1076L14.0814 53.473L23.0899 61.2182L32.5893 69.4091C35.6719 67.9496 39.2483 67.1146 43.0621 67.1146C46.8444 67.1146 50.3932 67.9359 53.4584 69.373L62.916 61.2181L71.9245 53.4729L72.6845 52.1076C73.6701 50.337 75.5796 48.731 78.8415 48.9742C81.885 49.2011 84.3559 51.4086 83.9699 54.436C83.7217 56.382 82.3274 57.9877 80.4354 58.5062L77.0917 59.4226L71.7739 67.0112Z",
    fill: "#926CA4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_176_105503)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4131 82.1185C40.2649 81.9554 40.5059 81.7269 40.7108 81.8081C41.254 82.0231 41.8685 82.0718 42.4761 81.909C43.9799 81.506 44.8724 79.9603 44.4694 78.4564C44.1706 77.3413 43.2435 76.5624 42.171 76.3985C42.0752 76.3839 42.0545 76.2442 42.1481 76.2191V76.2191C44.0691 75.7044 46.0438 76.8444 46.5585 78.7655C47.0733 80.6866 45.9332 82.6612 44.0121 83.176C42.6648 83.537 41.291 83.084 40.4131 82.1185Z",
    fill: "#FFBC65"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_176_105503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.0589 76.5356C51.6952 76.5356 55.7703 75.3474 59.7903 71.4271C59.7903 71.4271 62.9786 71.5756 65.3452 70.225C64.6706 66.478 62.7897 64.4585 62.7897 64.4585C63.6794 64.4999 64.7913 63.8829 64.7913 63.8829C64.1672 59.4007 61.3936 54.0419 61.3936 54.0419C61.3936 54.0419 62.3586 39.779 59.1715 38.8255C56.1725 37.9282 49.1649 44.2496 49.1649 44.2496C47.6577 43.5306 45.3697 43.2901 43.0589 43.2901C40.7482 43.2901 38.4598 43.5306 36.9526 44.2496C36.9526 44.2496 29.945 37.9282 26.946 38.8255C23.7589 39.779 24.7239 54.0419 24.7239 54.0419C24.7239 54.0419 21.9503 59.4007 21.3263 63.8829C21.3263 63.8829 22.4381 64.4999 23.3279 64.4585C23.3279 64.4585 21.4469 66.478 20.7723 70.225C23.1389 71.5756 26.3272 71.4271 26.3272 71.4271C30.3472 75.3474 34.4226 76.5356 43.0589 76.5356Z",
    fill: "#926CA4"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.416,
    cy: 27.416,
    r: 27.416,
    transform: "matrix(-1 8.74228e-08 8.74228e-08 1 70.4785 29.3479)",
    fill: "url(#paint0_radial_176_105503)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5872 49.1584C47.0429 48.9859 46.484 49.3594 46.4138 49.926C46.3376 50.541 46.3189 51.0751 46.3835 51.6922C46.4469 52.298 47.0874 52.6439 47.6402 52.3882C48.2403 52.1106 48.7381 51.8259 49.2486 51.5095C49.8425 51.1413 49.8752 50.2752 49.2755 49.9164C48.7467 49.6002 48.2212 49.3593 47.5872 49.1584Z",
    fill: "#C7AD8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7214 49.1611C39.2657 48.9885 39.8245 49.3621 39.8948 49.9287C39.971 50.5437 39.9897 51.0778 39.9251 51.6949C39.8617 52.3007 39.2212 52.6466 38.6684 52.3909C38.0683 52.1133 37.5705 51.8286 37.06 51.5122C36.466 51.1439 36.4334 50.2779 37.0331 49.9191C37.5619 49.6028 38.0874 49.362 38.7214 49.1611Z",
    fill: "#C7AD8D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3779 57.6732C46.9412 57.9602 46.3804 57.5754 46.6803 57.1475C47.4229 56.0877 48.5282 55.2733 49.8759 54.9122C51.2231 54.5512 52.5868 54.7036 53.7595 55.2495C54.2332 55.47 53.9402 56.0836 53.4186 56.0536C52.4202 55.9962 51.3518 56.101 50.2729 56.3901C49.1929 56.6795 48.2143 57.1235 47.3779 57.6732Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6687 56.0523C32.1472 56.0824 31.8541 55.4689 32.3275 55.2481C33.5011 54.7007 34.8665 54.5475 36.2152 54.9089C37.5656 55.2707 38.6725 56.0876 39.4152 57.1504C39.7145 57.5786 39.1533 57.9628 38.7169 57.6756C37.8791 57.1241 36.8985 56.6787 35.8161 56.3887C34.7366 56.0994 33.6676 55.9947 32.6687 56.0523Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6863 64.4776C39.6863 63.5418 43.0004 62.548 43.0004 62.548C43.0004 62.548 46.3145 63.5418 46.3145 64.4776C46.3145 65.4135 44.8307 67.0559 43.0004 67.0559C41.17 67.0559 39.6863 65.4135 39.6863 64.4776Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0273 58.5243C41.3566 58.5492 40.9212 59.2321 41.2498 59.8173C41.7673 60.7388 42.4325 61.5156 43.0287 61.5156C43.6382 61.5156 44.3891 60.6963 44.9133 59.7493C45.2249 59.1865 44.7969 58.5527 44.1542 58.5272C43.4152 58.4978 42.7666 58.4968 42.0273 58.5243Z",
    fill: "#FF9DB4"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_176_105503)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.1171,
    cy: 44.2355,
    rx: 3.08939,
    ry: 3.07096,
    transform: "rotate(30 66.1171 44.2355)",
    fill: "#FFC780"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.2921,
    cy: 11.8505,
    rx: 3.08939,
    ry: 3.07096,
    transform: "rotate(-150 20.2921 11.8505)",
    fill: "#FFC780"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.1914,
    cy: 20.2616,
    rx: 3.08939,
    ry: 1.9213,
    transform: "rotate(30 60.1914 20.2616)",
    fill: "#FFC780"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.4722,
    cy: 35.6007,
    rx: 3.08939,
    ry: 1.9213,
    transform: "rotate(30 51.4722 35.6007)",
    fill: "#FFC780"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.07829,
    cy: 1.29249,
    rx: 2.07829,
    ry: 1.29249,
    transform: "matrix(-0.248174 0.968715 0.968715 0.248174 32.7578 28.0591)",
    fill: "#FFC780"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.6109,
    cy: 26.5014,
    rx: 2.79271,
    ry: 1.31262,
    transform: "rotate(30 11.6109 26.5014)",
    fill: "#FFC780"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.07829,
    cy: 1.29249,
    rx: 2.07829,
    ry: 1.29249,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 57.8618 2)",
    fill: "#FFC780"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.8081,
    cy: 45.7553,
    rx: 3.08939,
    ry: 1.9213,
    transform: "rotate(-150 25.8081 45.7553)",
    fill: "#FFC780"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.08939,
    cy: 1.9213,
    rx: 3.08939,
    ry: 1.9213,
    transform: "matrix(0.866025 -0.5 -0.5 -0.866025 70.3281 37.8181)",
    fill: "#FFC780"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.08939,
    cy: 1.9213,
    rx: 3.08939,
    ry: 1.9213,
    transform: "matrix(0.965926 -0.258819 -0.258819 -0.965926 13.1841 33.5457)",
    fill: "#FFC780"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_176_105503",
    x: -18.0039,
    y: 38.9497,
    width: 122.014,
    height: 92.2957,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_176_105503"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_176_105503",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_176_105503",
    x: 30.3672,
    y: 68.0955,
    width: 26.3149,
    height: 27.2041,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_176_105503"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_176_105503",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_176_105503",
    x: -9.22754,
    y: 18.7383,
    width: 104.573,
    height: 97.7974,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_176_105503"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_176_105503",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_176_105503",
    x: 5.104,
    y: -1.3689,
    width: 73.7822,
    height: 53.3945,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.74902 0 0 0 0 0.521569 0 0 0 0 0.231373 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_176_105503"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_176_105503",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_176_105503",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.416 27.416) rotate(90) scale(27.416)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776082,
    stopColor: "#D9D9D9",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMooncatConfetti);
export default __webpack_public_path__ + "static/media/mooncat_confetti.c6fdea097477556680cd2e9fab49beb8.svg";
export { ForwardRef as ReactComponent };